"use strict";

angular.module("dragScroll")
.directive("dragScroll", function() {
    return {
        scope: {
            scrollOffset: "@",
            scrollRefresh: "@"
        },
        restrict: "A",
        link: function(scope) {
            var scrollOffset = scope.scrollOffset;
            var scrollRefresh = scope.scrollRefresh;
            var dragging = false;

            angular.element(document).on("drag", function(e) {
                dragging = false;
                if (e.originalEvent.clientY < scrollOffset) {
                    dragging = true;
                    scroll(-1);
                }

                if (e.originalEvent.clientY > (angular.element(window).height() - scrollOffset)) {
                    dragging = true;
                    scroll(1);
                }
            });

            angular.element(document).on("dragleave", function(e) {
                dragging = false;
            });

            function scroll(step) {
                var scrollY = angular.element(window).scrollTop();
                angular.element(window).scrollTop(scrollY + step);
                if (dragging)
                    setTimeout(function() {
                        scroll(step)
                    }, scrollRefresh);
            }
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./vendor/app-core/drag-scroll/drag-scroll.directive.js
// module id = 679
// module chunks = 0